import { Options } from "@angular-slider/ngx-slider/options";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: 'range-slider',
    templateUrl: './range-slider.component.html',
    styleUrls: ['./range-slider.component.scss']
})
export class RangeSlider implements OnInit {
    @Input() width : number = 200;
    allowedWidth: number;
    floorNotAllowedWidth: number;
    ceilNotAllowedWidth: number;

    @Input() floorShown: number;
    @Input() ceilShown: number;
    @Input() floorAllowed: number;
    @Input() ceilAllowed: number;

    private _minValue;
    get minValue(): number { 
      return this._minValue;
    }
    @Input()
    set minValue(val: number) {
      this._minValue = val;
    }
    @Output() minValueChange = new EventEmitter<number>();

    private _maxValue;
    get maxValue(): number { 
      return this._maxValue;
    }
    @Input()
    set maxValue(val: number) {
      this._maxValue = val;
    }
    @Output() maxValueChange = new EventEmitter<number>();

    options: Options = {
        disabled: false,
        floor: 0,
        ceil: 5,
        step: 1,
        minRange: 0,
        maxRange: 99999,
        combineLabels: (minValue: string, maxValue: string): string => {
            if (minValue == maxValue) {
                return minValue;
            }
            return minValue + ' - ' + maxValue;
        }
    };

    
    ngOnInit(): void {
        this.options = Object.assign({}, this.options, {
            floor: this.floorAllowed,
            ceil: this.ceilAllowed,
        });
        if (this.minValue < this.floorAllowed) {

        }
        this.setWidth();
    }

    private setWidth() {
        let stepLength = this.width / (this.ceilShown - this.floorShown);
        this.floorNotAllowedWidth = stepLength * (this.floorAllowed - this.floorShown);
        this.ceilNotAllowedWidth = stepLength * (this.ceilShown - this.ceilAllowed);
        this.allowedWidth = stepLength * (this.ceilAllowed - this.floorAllowed);
    }

    minValueChanged(newVal: number) {
        this.minValueChange.emit(newVal);
    }
    
    maxValueChanged(newVal: number) {
        this.maxValueChange.emit(newVal);
    }
}